import { ActionTree, ActionContext } from 'vuex'
import { RootState, useStore } from '@/store'
import { state, UserState } from './state'
import { Mutations } from './mutations'
import { UserMutationTypes } from './mutation-types'
import { UserActionTypes } from './action-types'
import { accountLoginRequest, getUserInfo } from '@/service/api/login'
import SessionCache from '@/utils/sessionCache'
import router, { resetRouter } from '@/router'
import { UserConstants } from '@/models/constant'
import { Account } from '@/models/service/user/IUser'
import { FormData } from '@/models/login'

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>
} & Omit<ActionContext<UserState, RootState>, 'commit'>

export interface Actions {
  [UserActionTypes.ACTION_LOGIN]({ commit }: AugmentedActionContext, account: Account): any
  [UserActionTypes.ACTION_RESET_TOKEN]({ commit }: AugmentedActionContext): void
  [UserActionTypes.ACTION_GET_USER_INFO]({ commit }: AugmentedActionContext): void
  // [UserActionTypes.ACTION_CHANGE_ROLES]({ commit }: AugmentedActionContext, role: string): void
  [UserActionTypes.ACTION_LOGIN_OUT]({ commit }: AugmentedActionContext): void
}

export const actions: ActionTree<UserState, RootState> & Actions = {
  async [UserActionTypes.ACTION_LOGIN]({ commit }: AugmentedActionContext, account: Account) {
    try {
      const res: any = await accountLoginRequest(account)
      if (res.errorCode !== 200) return Promise.reject(res.errorCode)
      SessionCache.setCache(UserConstants.TOKEN, res.data.accessToken)
      commit(UserMutationTypes.SET_TOKEN, res.data.accessToken)
      return Promise.resolve(res)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  [UserActionTypes.ACTION_RESET_TOKEN]({ commit }: AugmentedActionContext) {
    SessionCache.deleteCache(UserConstants.TOKEN)
    commit(UserMutationTypes.SET_TOKEN, '')
    commit(UserMutationTypes.SET_ROLES, [])
  },

  async [UserActionTypes.ACTION_GET_USER_INFO]({ commit }: AugmentedActionContext) {
    if (state.token === '') {
      throw Error('token is undefined!')
    }
    await getUserInfo().then((res) => {
      if (res?.errorCode === 200) {
        // commit(UserMutationTypes.SET_ROLES, res.data.roleId)
        commit(UserMutationTypes.SET_NAME, res.data.realName)
        commit(UserMutationTypes.SET_AVATAR, res.data.avatar)
        commit(UserMutationTypes.SET_INTRODUCTION, res.data.institution)
        commit(UserMutationTypes.SET_EMAIL, res.data.email)
        return res
      } else {
        SessionCache.deleteCache(UserConstants.TOKEN)
        commit(UserMutationTypes.SET_TOKEN, '')
        commit(UserMutationTypes.SET_ROLES, [])
        resetRouter()
        throw Error('Verification failed, please Login again.')
      }
    })
  },

  // async [UserActionTypes.ACTION_CHANGE_ROLES]({ commit }: AugmentedActionContext, role: string) {
  //   const token = role + '-token'
  //   const store = useStore()
  //   commit(UserMutationTypes.SET_TOKEN, token)
  //   setToken(token)
  //   await store.dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined)
  //   store.dispatch(PermissionActionType.ACTION_SET_ROUTES, state.roles)
  //   store.state.permission.dynamicRoutes.forEach((item: RouteRecordRaw) => {
  //     router.addRoute(item)
  //   })
  // },

  [UserActionTypes.ACTION_LOGIN_OUT]({ commit }: AugmentedActionContext) {
    console.log(commit)
    SessionCache.deleteCache(UserConstants.TOKEN)
    commit(UserMutationTypes.SET_TOKEN, '')
    commit(UserMutationTypes.SET_ROLES, [])
    resetRouter()
    router.push('/login')
  },
}
